import ajax from '@/utils/ajax.js'

// 推荐查询商家ID
 export function getBusinessIdByCode(params) {
  return ajax.post('/api/getBusinessIdByCode',params)
}